import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App.tsx";
import { ApolloProvider } from "@apollo/client";
import { client } from "@/helpers/apolloClient.ts";
import UserContextProvider from "@/contexts/UserContextProvider.tsx";
import { BrowserRouter as Router } from "react-router-dom";
import { ErrorBoundary } from "@sentry/react";
import * as Sentry from "@sentry/react";
import { getEnvName, SENTRY_PUBLIC_DSN } from "@/env.ts";
import { ThemeProvider } from "@/contexts/ThemeContext.tsx";
import { Toaster } from "sonner";

Sentry.init({
  dsn: SENTRY_PUBLIC_DSN,
  sendDefaultPii: true,
  environment: getEnvName().toString(),
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <Router>
          <ThemeProvider>
            <UserContextProvider>
              <App />
              <Toaster richColors position="top-right" />
            </UserContextProvider>
          </ThemeProvider>
        </Router>
      </ErrorBoundary>
    </ApolloProvider>
  </StrictMode>,
);
